import { REGISTER_AUTH_TOKEN, SHOW_LOCK_SCREEN, HIDE_LOCK_SCREEN, } from '../actions/auth';

const auth = (state = {}, event = {}) => {
  switch (event.type) {
    case REGISTER_AUTH_TOKEN:
      return {
        ...state,
        authentication: event.data,
      };
    case SHOW_LOCK_SCREEN:
      return {
        ...state,
        isLocked: true,
      };
    case HIDE_LOCK_SCREEN:
      return {
        ...state,
        isLocked: false,
      };
    default:
      return state;
  }
};

export default auth;
